import {httpClient} from '../../utils/request'
export const gotoUrl = {
    methods: {
        gotoUrl(path) {
            if (this.$route.path !== path) {
                this.$router.push(path).catch(() => {});
            }
        },
    },
}

export const baseUrl = process.env.VUE_APP_API_BASE_URL
export let menuItems =  async () => {
    let menuItems = []
    try {
        const data = await httpClient.getSync({
            url: 'web/getNavigations',
            data: {}
        })
        let rote = []
        data.data.forEach(item => {
            if(item.navigationId != 1971504321417641986){
                let roteData = {}
                roteData.link = item.pageUrl
                roteData.en  = item.navigationNameen
                roteData.cn  = item.navigationNamecn
                let subItems = []
                if(item.children){
                    let index = 0
                    item.children.forEach(e => {
                        index++
                        let subItem = {}
                        subItem.name = e.navigationNamecn
                        subItem.code = e.pageUrl
                        subItem.link = item.pageUrl + '?tab=' + e.pageUrl
                        if(e.pageUrl.indexOf('publicDetail') > -1){
                            subItem.link = subItem.link + '&pub=' + e.navigationId
                        }
                        subItems.push(subItem)
                    })
                }
                roteData.subItems = subItems
                rote.push(roteData)
            }
        })
        menuItems.length = 0;
        menuItems.push(...rote);
        return menuItems
    } catch (error) {
        console.error('Failed to fetch navigation:', error)
        return []
    }
}

